import React, { useState, useEffect } from "react";
import images from '../../themes/appImage'
import { Link } from "react-router-dom";
import appconstants from "../../themes/appconstant";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import ButtonLayout from "../../common/layoutButton";
import { loginLoad } from '../../redux/slices/auth.slice'


const Login = () => {
  const dispatch = useDispatch();
  const rememberedEmail = localStorage.getItem("rememberedEmail") || "";
  const initialValues = {
    email: rememberedEmail,
    password: "",
  };
  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Please enter a valid email address.")
      .required("Please enter an email address."),
    password: Yup.string().required("Please enter a password."),
  });

  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(!!rememberedEmail); // Initialize with true if rememberedEmail exists

  const handleSubmit = (values, { setSubmitting }) => {
    if (rememberMe) {
      localStorage.setItem("rememberedEmail", values.email);
    } else {
      localStorage.removeItem("rememberedEmail");
    }
    dispatch(loginLoad(values));
    setSubmitting(false);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="w-[100vw] h-[100vh] bg-background flex flex-col items-center justify-between">
      <div className="min-w-[350px] max-w-[424px] m-auto flex items-center flex-col mt-5">
        <img className="mb-5" src={images.appLogo} alt="metafit-logo" />
        <div className="w-full bg-white border shadow-metafit-shadow rounded-lg p-5 md:p-2 sm:w-[100vw]">
          <div className="text-2xl font-semibold text-dark text-center my-6">
            {appconstants.loginWithEmail}
          </div>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {() => (
              <Form className="w-[95%] mx-auto">
                <div className="mb-5">
                  <label
                    htmlFor="email"
                    className="block mb-2 text-sm font-[400] text-dark"
                  >
                    {appconstants.Email}
                  </label>
                  <Field
                    type="email"
                    name="email"
                    className="border border-gray-300 text-dark text-sm rounded-lg block w-full py-[12px] px-[16px] h-[48px] focus:outline-none focus:border-gray-300"
                    placeholder="Enter your email"
                  />
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="text-red-500 text-xs font-normal"
                  />
                </div>
                <div className="mb-5 relative">
                  <label
                    htmlFor="password"
                    className="block mb-2 text-sm font-[400] text-dark"
                  >
                    {appconstants.password}
                  </label>
                  <Field
                    type={showPassword ? "text" : "password"}
                    name="password"
                    className="border border-gray-300 text-dark text-sm rounded-lg block w-full py-[12px] px-[16px] h-[48px] pr-[35px] focus:outline-none focus:border-gray-300"
                    placeholder="Enter your password"
                  />
                  {showPassword ? (
                    <EyeOutlined
                      className="absolute right-3 top-[44px] transform -translate-y-50 cursor-pointer"
                      onClick={togglePasswordVisibility}
                      style={{ color: "#2F2F2F66" }}
                    />
                  ) : (
                    <EyeInvisibleOutlined
                      className="absolute right-3 top-[44px] transform -translate-y-50 cursor-pointer"
                      onClick={togglePasswordVisibility}
                      style={{ color: "#2F2F2F66" }}
                    />
                  )}
                  <ErrorMessage
                    name="password"
                    component="div"
                    className="text-red-500 text-xs font-normal"
                  />
                </div>
                <div className="flex mb-[40px]">
                  <div className="flex w-full justify-between items-center">
                    <div className="flex">
                      <div className="flex justify-between items-center">
                        <input
                          id="remember"
                          type="checkbox"
                          checked={rememberMe}
                          onChange={(e) => setRememberMe(e.target.checked)}
                          className="w-4 h-4 border border-[#2F2F2FCC] rounded bg-gray-50 focus:ring-3 focus:ring-blue-300"
                        />
                        <label
                          htmlFor="remember"
                          className="ms-2 text-sm font-medium text-[#2F2F2FCC]"
                        >
                          {appconstants.rememberMe}
                        </label>
                      </div>
                    </div>
                    <div className="text-sm text-[#2F2F2FCC] font-medium">
                      <Link to="/forgot-password">
                        {appconstants.forgotPassword}
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="mb-5" >
                  <ButtonLayout text="Login" className="ml-1/4" />
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
      <div className="text-sm font-normal text-light mb-3">
        {appconstants.metafitRights}
      </div>
    </div>
  );
};

export default Login;
